import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Main from './views/Main';
import Header from './views/Header';
import Inquiry from './views/Inquiry';
import Footer from './views/Footer';
import Download from './views/Download';
import Notice from './views/Notice';
import Login from './views/admin/login';
import AdminInquiry from './views/admin/inquiry';
import { CustomAlretDialog } from './views/Components/Dialog';


export const Routers = () => {
  return (
    <Router>
      <RoutesWithHeaderAndFooter />
    </Router>
  );
};

const RoutesWithHeaderAndFooter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminRoute = location.pathname.startsWith('/admin');


  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');

  const showDialog = (message) => {
    setDialogMessage(message);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    const token = sessionStorage.getItem('gonggam-accessToken');

    if (location.pathname === '/admin') {
      // '/admin' 경로로 접근했을 때 무조건 /admin/login으로 리다이렉트
      navigate('/admin/login', { replace: true });
    }

    if (location.pathname.startsWith('/admin/inquiry')) {
      if (!token) {
        showDialog('세션이 만료되었습니다. 다시 로그인을 해주세요');
        // 토큰이 없으면 /admin/login으로 리다이렉트
        navigate('/admin/login', { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return (
    <>
      {!isAdminRoute && <Header />} {/* admin 경로가 아니면 Header 렌더링 */}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/inquiry/:category" element={<Inquiry />} />
        <Route path="/download" element={<Download />} />
        <Route path="/download/:category" element={<Download />} />
        <Route path="/notice" element={<Notice />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/inquiry" element={sessionStorage.getItem('gonggam-accessToken') ? <AdminInquiry /> : <></>} />
        {/* <Route path="/admin/inquiry" element={<AdminInquiry />} /> */}
      </Routes>
      {!isAdminRoute && <Footer />} {/* admin 경로가 아니면 Footer 렌더링 */}


      <CustomAlretDialog
        open={dialogOpen}
        message={dialogMessage}
        close={handleDialogClose}
      />
    </>
  );
};
